/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdatePurchaseApplicationTemplateRequest
 */
export interface UpdatePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'templateName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'scopeDisclosure': UpdatePurchaseApplicationTemplateRequestScopeDisclosureEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'templateCategory': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'templateDetail': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'purposeOfUse': UpdatePurchaseApplicationTemplateRequestPurposeOfUseEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'isOnDemandCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'remarks': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'approvers': Array<string>;
}

export const UpdatePurchaseApplicationTemplateRequestScopeDisclosureEnum = {
    public: 'PUBLIC',
    individual: 'INDIVIDUAL'
} as const;

export type UpdatePurchaseApplicationTemplateRequestScopeDisclosureEnum = typeof UpdatePurchaseApplicationTemplateRequestScopeDisclosureEnum[keyof typeof UpdatePurchaseApplicationTemplateRequestScopeDisclosureEnum];
export const UpdatePurchaseApplicationTemplateRequestPurposeOfUseEnum = {
    software: 'SOFTWARE',
    fixtures: 'FIXTURES',
    conference: 'CONFERENCE',
    entertainment: 'ENTERTAINMENT',
    travel: 'TRAVEL',
    other: 'OTHER',
    initialValue: 'INITIAL_VALUE'
} as const;

export type UpdatePurchaseApplicationTemplateRequestPurposeOfUseEnum = typeof UpdatePurchaseApplicationTemplateRequestPurposeOfUseEnum[keyof typeof UpdatePurchaseApplicationTemplateRequestPurposeOfUseEnum];


